import { Layout, Tabs } from 'antd'

import { GLOBAL_CLIENT } from '../../helpers/GlobalClient'
import { useTranslation } from 'react-i18next'
import 'moment/locale/vi'
import { observer } from 'mobx-react-lite'
import { useStore } from '../../hooks'
import { DELIVERY_CONST, DELIVERY_TAB_CONST, getPage, tabConfigPrice } from '../../helpers/constants'
import ContentFee from './Content'
import { useEffect, useState } from 'react'
const { Content } = Layout
const TabPane = Tabs.TabPane

const ShippingManagementScreen = observer((props: any) => {
   const { t } = useTranslation()
   const OrdersStore = useStore('OrdersStore')

   const onChangeTab = (key: string) => {
      OrdersStore.setActiveTab(key)
   }

   // useEffect(() => {
   //    getListData(DELIVERY_CONST[0].value, 0)
   // }, [])
   // const getListData = async (deliveryId: string, currentPage: number, param?: any) => {
   //    try {
   //       // setIsLoading(true)
   //       const offset = getPage(currentPage)
   //       const params = { offset, ...param }

   //       const res = await OrdersStore.getListDeliveryMaping(deliveryId, params)
   //       OrdersStore.setActiveTab(deliveryId)
   //    } catch (error) {
   //       //  console.log(error)
   //    } finally {
   //       // setIsLoading(false)
   //    }
   // }
   return (
      <Content {...props}>
         <Tabs defaultActiveKey={OrdersStore.activeTab} destroyInactiveTabPane={true} onChange={onChangeTab}>
            {DELIVERY_TAB_CONST.map((DELIVERY: any) => {
               return (
                  <TabPane tab={DELIVERY.label} key={DELIVERY.value}>
                     <ContentFee {...props} idTab={DELIVERY.value} key={DELIVERY.value} />
                  </TabPane>
               )
            })}
         </Tabs>
      </Content>
   )
})

export default ShippingManagementScreen
